import { Proportions } from "types/generic/types";

export const CF_PROPORTIONS_DICTIONARY: Proportions = {
  "6:6": ["6", "6"],
  "5:7": ["5", "7"],
  "7:5": ["7", "5"],
  "4:8": ["4", "8"],
  "8:4": ["8", "4"],
  "3:9": ["3", "9"],
  "9:3": ["9", "3"],
  "2:10": ["2", "10"],
  "10:2": ["10", "2"],
  "1:11": ["1", "11"],
  "11:1": ["11", "1"],
};
